import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { FormatRowPipe } from '../pipes/format-row.pipe';

@Directive({ selector: '[formatNumber]' })
export class FormatNumberDirective implements OnInit {
  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private formatRowPipe: FormatRowPipe
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.el.value = this.formatRowPipe.transformInput(
      this.el.value || this.el.getAttribute('ng-reflect-model') || '0'
    );
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.el.value = this.formatRowPipe.parse(value); // opossite of transform
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.el.value = this.formatRowPipe.transformInput(value);
    // console.log(this.el);
  }
}
